exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-body[data-v-5f253559]{width:100%}.icon-body .icon-list[data-v-5f253559]{height:200px;overflow-y:auto}.icon-body .icon-list .icon-item[data-v-5f253559]{cursor:pointer}.icon-body .icon-list .icon-item .svg[data-v-5f253559]{vertical-align:middle;width:30px;height:30px}.icon-body .icon-list .icon-item .name[data-v-5f253559]{padding-left:2px;display:inline-block;vertical-align:middle;overflow:hidden}", ""]);

// exports
